import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
import { useHistory,} from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,Timer,AudioLines,
  FolderHeart, Forward,Earth,ListChecks,Gift,Settings,BetweenHorizontalStart,
  ImagePlay,Film,AlarmSmoke,BellElectric,CircleCheck,LayoutGrid ,CornerDownRight,BotMessageSquare,ChevronUp,ChevronDown,
  GripHorizontal,
  CopyPlus,
  Bookmark,
  Pencil,
  Trash2,
  Recycle,
  Play,
  ChevronLeft,
  ChevronRight} from 'lucide-react';import Snackbar from "../../../../Snackbar";
import CreateSubCoursePopUp from "./CreateSubCoursePopUp";
import ContentFolderCard from "../ContentFolderCard";
import { getAllMilestonesBySubCourseId, getAllSubCoursesByCourseId, reArrangeSubCourses } from "../../../../store/actions/CreateContent/OrganizeAPI/SubCoursesAPIs";
import FolderFilterCardTwo from "../FolderFilterCardTwo";
import FolderFilterCardThree from "../FolderFilterCardTwoThree";
import FolderFilterCard from "../FolderFilterCard";
import AddToFolderButton from "../AddToFolderButton";
import CreateMileStonePopup from "./CreateMileStonePopUp";
import LoadingButton from "../../../Loading/LoadingButton";
import HighLightsForCourse from "../../CreateCourse/HighLightsForCourse";
import AddHighlightsSubCourse from "./AddHighlightSubCourse";
import AddHighlightsSection from "./AddHighlightsSection";
import AddSkillsSection from "./AddSkillSection";
import { createNewSection, getAllSectionsByMilestoneId, reArrangeSections } from "../../../../store/actions/CreateContent/FolderAPI/SectionAPI";
import CreateSectionPopup from "./CreateSectionPopUp";
import AreYouSurePopUp from "../ContentPopUp/AreYouSurePopUp";
import ChapterFolderPanel from "./ChapterFolderPanel";
import { addEntityToAnyEntity, createNewChapter, getAllChaptersBySectionId } from "../../../../store/actions/CreateContent/FolderAPI/ChapterAPI";
import CreateChapterPopup from "./CreateChapterPopup";

import contentfolder from "../../../contentImgs/folder.png";
import CreateFolderInChapterPopup from "./CreateFolderInChapterPopup";
import FolderContentPopUp from "./FolderContentPopUp";
const SectionFolderPanel =({mileStoneSectionSend,mileStoneItemSend,selectCoursePopUp,SubCourseData,setOpenMilestoneForSubCourse,setCreateNewMileStone})=>{

     const dispatch = useDispatch();
         const user = useSelector((state)=>state?.user?.user);
               const [activeFilterOne, setActiveFilterOne] =useState(true);
                       const [activeFilterTwo, setActiveFilterTwo] =useState(true);
                       const [activeFilterThree, setActiveFilterThree] =useState(false);
                       const [activeFilterFour, setActiveFilterFour] =useState(false);
                       const [activeFilterASC, setActiveFilterASC] =useState(true);
                       const [activeFilterDESC, setActiveFilterDESC] =useState(false);
                     
         const [snackbarVisible, setSnackbarVisible] = useState(false);
                          const [snackbarColor, setSnackbarColor] = useState("#958FDA");
                          const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
                    
                                  const mainMenuStatus = useSelector((state)=>state?.app?.mainMenuStatus);
                       const showSnackbar = () => {
                         setSnackbarVisible(true);
                       };
                      
                       const hideSnackbar = () => {
                         setSnackbarVisible(false);
                       };
                 
                 
                            
                            
                         
                        const [animate, setAnimate] = useState(false);
          
                            const [loader , setLoader] =useState({status:false});
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
      const [openAppDesignPopUp,setopenAppDesignPopUp]  = useState(false);
      const [openAppDesignPopUpInnerContent,setopenAppDesignPopUpInnerContent]  = useState("appThemes");

      
const token = useSelector((state)=>state?.course?.course?.token);
       const currentToken = useSelector((state)=>state?.user?.user?.token);
       const user_email = useSelector((state)=>state?.user?.user?.user_email
      );
      
      const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
      
      const courseData = useSelector((state)=>state?.course?.course);
      
      const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
        const appId = useSelector((state)=>state?.app?.app?.ID);
                       const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
     
           const [visibility,setVisibility] =useState("public");
           const [orderBy,setOrderBy] =useState("ASC");
           const [itemArr, setItemArr] = useState([]);
           const [itemReorderArr, setItemReorderArr] = useState([]);
           const [itemId, setItemId] = useState("");
           const [itemChapterId, setItemChapterId] = useState("");
            const [deleteItemPopUp, setDeleteItemPopUp] = useState(false);
            
             const [newFolderInSectionPopUp ,setNewFolderInSectionPopUp] =useState(false);
              const [currentChapterID ,setCurrentChapterId] =useState("");
                        const [deleteItemChapterPopUp, setDeleteItemChapterPopUp] = useState(false);
           const [deleteSubCoursePopUp, setDeleteSubCoursePopUp] = useState(false);
           const [itemArrLoading, setItemArrLoading] = useState([{},{},{},{},{}]);
           const [itemArrChapter, setItemArrChapter] = useState([]);
           const [itemArrChapterInn, setItemArrChapterInn] = useState([]);
           const [itemArrLoadingChapter, setItemArrLoadingChapter] = useState([{},{},{},{},{}]);
          
           const [openContentInFolder, setOpenContentInFolder] = useState("");
           const [createNewChapterPopUp ,setCreateNewChapterPopUp]= useState("");
           
            const [newFolderInChapterPopUp ,setNewFolderInChapterPopUp] =useState(false);
            const [chapterItem ,setChapterItem] =useState({});
 const [sectionItem ,setSectionItem] =useState({});
 const [mileStoneItem ,setMileStoneItem] =useState(mileStoneItemSend);
 const [mileStoneSection ,setMileStoneSection] =useState(mileStoneSectionSend);
 const [sectionID ,setSectionID] =useState("");
      const [sectionMenuOrder ,setSectionMenuOrder] =useState("");
    
      const [currentEntityID ,setCurrentEntityId] =useState("");
      const [currentFolder ,setCurrentFolder] =useState();
     const [newChapterPopUp ,setNewChapterPopUp] =useState(false);
 const [newSectionPopUp ,setNewSectionPopUp] =useState(false);
 const [openFolderContentPopUp ,setOpenFolderContentPopUp] =useState(false);


  const updateItemData = (ID, newData) => {


  setSectionItem(newData);
  const updatedItems = itemArr.map(item =>
    item?.ID === ID ? { ...item, Name :newData?.Name
        , Description :newData?.Description
        , FAQs :newData?.FAQs
        ,Skills :newData?.Skills
          
    } : item
  
  ); 

 // console.log(updatedItems)
  setItemArr(updatedItems);
};
const sendBackItem = (section) => {

  // console.log(mileStone)
  setSectionItem(section);
  const updatedItems = [...itemArr, section]
  const updatedItemsMenuorder = [...itemReorderArr, {ID:section?.ID,menuOrder:section?.menuOrder}]
  setItemReorderArr( updatedItemsMenuorder);
 // console.log(updatedItems)
  setItemArr(updatedItems);
};


  const updateItemChapterData = (ID, newData) => {


    setChapterItem(newData);
    const updatedItems = itemArrChapter.map(item =>
      item?.ID === ID ? { ...item, Name :newData?.Name
          , Description :newData?.Description
          ,makeFree :newData?.makeFree
          ,Highlights :newData?.Highlights
            
      } : item
    
    ); 
  
   // console.log(updatedItems)
    setItemArrChapter(updatedItems);
  };
  const sendBackItemChapter = (section) => {
  
    // console.log(mileStone)
    setChapterItem(section);
    const updatedItems = [...itemArrChapter, section]
   // console.log(updatedItems)
    setItemArrChapter(updatedItems);
    
  };
  const sendBackItemChapterInn = (section) => {
  
    const updatedItems = [...itemArrChapterInn, section]
   // console.log(updatedItems)
    setItemArrChapterInn(updatedItems);
    
  };

useEffect((e)=>{
    setMileStoneItem(mileStoneItemSend)
    setMileStoneSection(mileStoneSectionSend)
    
    },[mileStoneItemSend,mileStoneSectionSend,]);
      useEffect((e)=>{
      
        fireGetAllSectionsByMileStoneId();
        },[visibility,orderBy,postIdCourse,mileStoneSectionSend?.ID]);
  const fireGetAllSectionsByMileStoneId=()=>{
          setItemArr([])
         
        
          setItemArrLoading([{},{},{},{},{}])
        // Popup When Course is not selected
          if(courseData){}else{selectCoursePopUp(true);}
        
        setLoader({status:true});
            // console.log({
            //     token:AppToken,courseId:postIdCourse ,postParent:mileStoneSectionSend?.ID,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
            //     appToken:AppToken,visibility:visibility,orderBy:orderBy
            //     });
            
              const apiData = dispatch(addEntityToAnyEntity({
                token:AppToken,courseId:postIdCourse ,parentEntityType:"Milestone",parentEntityId:mileStoneSectionSend?.ID,postParent:mileStoneSectionSend?.ID,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
                appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,visibility:visibility,orderBy:orderBy,editType:"getAllContents",
                }));
              /* get response as Promise   */
              apiData.then(response => {
                console.log(response)
        
                if(response){
                 
                  if(response){
                setResponseMessage(response?.message);
                setSnackbarColor("rgba(144, 202, 249,1)");
              
                if(response)  {setItemArr(response?.contents);
                  
                  setMileStoneSection(response?.contents[0])
                  setItemId(response?.contents[0]?.contentID);fireGetAllChaptersBySectionId(response?.contents[0]?.contentID);
                  if(setCreateNewMileStone){setVisibility('public');setopenAppDesignPopUp(true);setopenAppDesignPopUpInnerContent("createMileStone");}
      
                  const reorderArray = response?.contents.map(item => ({
                    ID: item.ID,
                    menuOrder: item.menuOrder
                }));
                setItemReorderArr(reorderArray);
                //  console.log(reorderArray)
               
                }else{setItemArr([]);};
                setItemArrLoading([]);
            setLoader({status:false});
            
            // setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
            },1000)
               }else{
            //     setResponseMessage("Something Went Wrong...");
                  
            //     setSnackbarColor("#958FDA");
            //   //  selectCoursePopUp(true);
                
                 
            // setLoader({status:false});
            // setItemArrLoading([{},{},{},{},{}]);
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
               }
                  
                // dispatch({
                //   type: "UPDATE_APP_TOKEN",
                  
                //   payload:response?.course?.AppToken
                // });  
              //  console.log(response?.course);
             
               // 
               if(response?.logout){
                // pop up response?.logoutInfo
                //console.log(response?.logoutInfo)
            
                setResponseMessage("You are Logged Out!!!");
                  
                setSnackbarColor("#958FDA");
               selectCoursePopUp(true);
                
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                setTimeout(()=>{
                  dispatch({type:"LOGOUT"});
            
                },3000)
                
              }
            /* resetting Login input Fields */
            
                }else{
                  setResponseMessage("Something Went Wrong...");
                  
                  setSnackbarColor("#958FDA");
                 selectCoursePopUp(true);
                 setItemArrLoading([{},{},{},{},{}]);
                   
              setLoader({status:false});
              
              setSnackbarVisible(true);
              setTimeout(()=>{
                
                setSnackbarVisible(false);
               
                 
              },3000)    }
            
              }).catch(error => {
             
                //popup of error Info
                setResponseMessage("Something Went Wrong...");
                  
                setSnackbarColor("#958FDA");
               selectCoursePopUp(true);
                
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                console.error(error);
              });
         }
  const fireGetAllContentssByChapterId=(ChapterIDVal)=>{
          setItemArrChapterInn([])
         
        
        // Popup When Course is not selected
          if(courseData){}else{selectCoursePopUp(true);}
        
        setLoader({status:true});
           
              const apiData = dispatch(addEntityToAnyEntity({
               courseId:postIdCourse ,parentEntityType:"chapter",parentEntityId:ChapterIDVal,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
                appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,visibility:visibility,orderBy:orderBy,
                editType:"getAllContents",
                }));
              /* get response as Promise   */
              apiData.then(response => {
                // console.log(response)
        
                if(response){
                 
                  if(response?.contents){
                setResponseMessage(response?.message);
                setSnackbarColor("rgba(144, 202, 249,1)");
              
                if(response?.contents)  {setItemArrChapterInn(response?.contents); 
                  
                    //  console.log(reorderArray)
               
                }else{setItemArrChapterInn([]);};
                
            setLoader({status:false});
            
            // setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
            },1000)
               }else{
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
               }
                  
                
               if(response?.logout){
                // pop up response?.logoutInfo
                //console.log(response?.logoutInfo)
            
                setResponseMessage("You are Logged Out!!!");
                  
                setSnackbarColor("#958FDA");
               selectCoursePopUp(true);
                
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                setTimeout(()=>{
                  dispatch({type:"LOGOUT"});
            
                },3000)
                
              }
            /* resetting Login input Fields */
            
                }else{
                  setResponseMessage("Something Went Wrong...");
                  
                  setSnackbarColor("#958FDA");
                 selectCoursePopUp(true);
                 setItemArrLoading([{},{},{},{},{}]);
                   
              setLoader({status:false});
              
              setSnackbarVisible(true);
              setTimeout(()=>{
                
                setSnackbarVisible(false);
               
                 
              },3000)    }
            
              }).catch(error => {
             
                //popup of error Info
                setResponseMessage("Something Went Wrong...");
                  
                setSnackbarColor("#958FDA");
               selectCoursePopUp(true);
                
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                console.error(error);
              });
         }

 const handleDeleteFolderInChapter=(val,folderIDK)=>{
           let editType=val;
             
           setLoader({status:true});
         
                 const apiData = dispatch( createNewChapter({
                  token:token,courseId:postIdCourse ,postParent:sectionItem?.ID ,userEmail:user_email?user_email:null,
                  currentToken:currentToken?currentToken:null,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,
                  editType:editType,postId:folderIDK,menuOrder:1}));
              
             /* get response as Promise   */
             apiData.then(response => {
               if(response){
         
                //  console.log(response)
                 if(response?.chapter){
               setResponseMessage(response?.message);
               setSnackbarColor("rgba(144, 202, 249,1)");
             
                
           setLoader({status:false});
           
           setSnackbarVisible(true);
           setTimeout(()=>{
             
             setSnackbarVisible(false);
            
            if(val=="deleteChapter"){
             // setActiveFilterTwo(false);;setActiveFilterThree(true);
             const removedItems = itemArrChapterInn.filter(item => item?.ID !== response?.chapter?.ID);
             setItemArrChapterInn(removedItems);
            } 
            
         
           },1000)
              }else{
               setResponseMessage("Something Went Wrong...");
                 
               setSnackbarColor("#958FDA");
            
                
           setLoader({status:false});
           
           setSnackbarVisible(true);
           setTimeout(()=>{
             
             setSnackbarVisible(false);
            
              
           },3000)
              }
                 
              
              if(response?.logout){
              
               setResponseMessage("You are Logged Out!!!");
                 
               setSnackbarColor("#958FDA");
            
                
           setLoader({status:false});
           
           setSnackbarVisible(true);
           setTimeout(()=>{
             
             setSnackbarVisible(false);
            
              
           },3000)
               setTimeout(()=>{
                 dispatch({type:"LOGOUT"});
           
               },3000)
               
             }
           /* resetting Login input Fields */
           
               }else{
                 setResponseMessage("Something Went Wrong...");
                 
                 setSnackbarColor("#958FDA");
              
                  
             setLoader({status:false});
             
             setSnackbarVisible(true);
             setTimeout(()=>{
               
               setSnackbarVisible(false);
              
                
             },3000)    }
           
             }).catch(error => {
            
               //popup of error Info
               setResponseMessage("Something Went Wrong...");
                 
               setSnackbarColor("#958FDA");
            
                
           setLoader({status:false});
           
           setSnackbarVisible(true);
           setTimeout(()=>{
             
             setSnackbarVisible(false);
            
              
           },3000)
               console.error(error);
             });
            
             }
    
         const handleDeleteSection=(val,sectionID)=>{
           let editType=val;
             
           setLoader({status:true});
         
                 const apiData = dispatch( createNewSection({
                  token:token,courseId:postIdCourse ,postParent:mileStoneSection?.ID ,userEmail:user_email?user_email:null,
                  currentToken:currentToken?currentToken:null,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,
                  editType:editType,postId:sectionID,menuOrder:itemArr?.length+1}));
              
             /* get response as Promise   */
             apiData.then(response => {
               if(response){
         
                //  console.log(response)
                 if(response?.section){
               setResponseMessage(response?.message);
               setSnackbarColor("rgba(144, 202, 249,1)");
             
                
           setLoader({status:false});
           
           setSnackbarVisible(true);
           setTimeout(()=>{
             
             setSnackbarVisible(false);
            
            if(val=="deleteSection"){
             // setActiveFilterTwo(false);;setActiveFilterThree(true);
             const removedItems = itemArr.filter(item => item?.ID !== response?.section?.ID);
             setItemArr(removedItems);
            } 
             if(val=="restoreSection"){
               // setActiveFilterTwo(true);;setActiveFilterThree(false);
               const removedItems = itemArr.filter(item => item?.ID !== response?.section?.ID);
             setItemArr(removedItems);
             }
         
           },1000)
              }else{
               setResponseMessage("Something Went Wrong...");
                 
               setSnackbarColor("#958FDA");
            
                
           setLoader({status:false});
           
           setSnackbarVisible(true);
           setTimeout(()=>{
             
             setSnackbarVisible(false);
            
              
           },3000)
              }
                 
              
              if(response?.logout){
              
               setResponseMessage("You are Logged Out!!!");
                 
               setSnackbarColor("#958FDA");
            
                
           setLoader({status:false});
           
           setSnackbarVisible(true);
           setTimeout(()=>{
             
             setSnackbarVisible(false);
            
              
           },3000)
               setTimeout(()=>{
                 dispatch({type:"LOGOUT"});
           
               },3000)
               
             }
           /* resetting Login input Fields */
           
               }else{
                 setResponseMessage("Something Went Wrong...");
                 
                 setSnackbarColor("#958FDA");
              
                  
             setLoader({status:false});
             
             setSnackbarVisible(true);
             setTimeout(()=>{
               
               setSnackbarVisible(false);
              
                
             },3000)    }
           
             }).catch(error => {
            
               //popup of error Info
               setResponseMessage("Something Went Wrong...");
                 
               setSnackbarColor("#958FDA");
            
                
           setLoader({status:false});
           
           setSnackbarVisible(true);
           setTimeout(()=>{
             
             setSnackbarVisible(false);
            
              
           },3000)
               console.error(error);
             });
            
             }


         const handleReArrangeSections =(reorderedItemsArray)=>{
        //  console.log({
        //      token:AppToken,courseId:postIdCourse ,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
        //      appToken:AppToken,menuOrder:JSON.stringify(reorderedItemsArray),orderBy:orderBy
        //      })
         
         
           const apiData = dispatch(reArrangeSections({
             token:AppToken,courseId:postIdCourse ,postParent:mileStoneSection?.ID ,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
             appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,menuOrder:JSON.stringify(reorderedItemsArray),orderBy:orderBy
             }));
           /* get response as Promise   */
           apiData.then(response => {
            //  console.log(response)
         
          
              
               if(response){
                 
           // setSnackbarVisible(true);
             setResponseMessage("Saved Successfully!!!");
             setSnackbarColor("rgba(144, 202, 249,1)");
           
            
         setLoader({status:false});
         
         setTimeout(()=>{
           
           setSnackbarVisible(false);
         },1000)
            }else{
         
         setSnackbarVisible(true);
         setTimeout(()=>{
           
           setSnackbarVisible(false);
          
            
         },3000)
            }
               
             
            if(response?.logout){
             // pop up response?.logoutInfo
             //console.log(response?.logoutInfo)
         
             setResponseMessage("You are Logged Out!!!");
               
             setSnackbarColor("#958FDA");
            selectCoursePopUp(true);
             
              
         setLoader({status:false});
         
         setSnackbarVisible(true);
         setTimeout(()=>{
           
           setSnackbarVisible(false);
          
            
         },3000)
             setTimeout(()=>{
               dispatch({type:"LOGOUT"});
         
             },3000)
             
           }
         
         
            
         
           }).catch(error => {
          
             //popup of error Info
             setResponseMessage("Something Went Wrong...");
               
             setSnackbarColor("#958FDA");
             
         setLoader({status:false});
         
         setSnackbarVisible(true);
         setTimeout(()=>{
           
           setSnackbarVisible(false);
          
            
         },3000)
             console.error(error);
           });
         }



         const flattenedData = itemArr!=[]?Object.values(itemArr):'';

         const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';
 
const setArrayItemsChapter=(chapterArray)=>{
    setItemArrChapter(chapterArray);
}
 const [draggedIndex, setDraggedIndex] = useState('');
 const [hoveredDropZone, setHoveredDropZone] = useState(null); // Track hovered drop zone
 const [selectedItemIndex, setSelectedItemIndex] = useState(null); // Track hovered drop zone
 
 const handleDragStart = (e, index) => {
   
   e.dataTransfer.effectAllowed = 'move';
   e.dataTransfer.setData("dragIndex", index);
   
 };
 
 const handleDrop = (e, dropIndex) => {
   const dragIndex = e.dataTransfer.getData("dragIndex");
   if (dragIndex === dropIndex) return;
 
   const updatedItems = [...itemArr];
   const [draggedItem] = updatedItems.splice(dragIndex, 1);
   updatedItems.splice(dropIndex, 0, draggedItem);
 
   const reorderedItems = updatedItems.map((item, index) => ({
     ...item,
     ID: item.ID,
     menuOrder:index+1
   }));
   const updatedItemsReorder = [...itemReorderArr];
   const [draggedItemReorder] = updatedItemsReorder.splice(dragIndex, 1);
   updatedItemsReorder.splice(dropIndex, 0, draggedItemReorder);
 
 
   setItemArr(reorderedItems);
 
   const reorderedItemsReorder = updatedItemsReorder.map((item, index) => ({
     ...item,
     ID: item.ID,
     menuOrder:index+1
   }));
 
 
//  console.log(reorderedItemsReorder)
   setItemReorderArr(reorderedItemsReorder);
   
   setTimeout(()=>{
    
    handleReArrangeSections(reorderedItemsReorder)
    ;},1000)
   // setTimeout(()=>{setReorderFolderPopUp(true);},1000)
   // pop up For Saving This Order . Send Array Json To Backend
   // console.log(itemReorderArr)
   setDraggedIndex('');
   setHoveredDropZone(null); // Reset hovered drop zone
 };
 
 const handleDragOver = (e, index) => {
   e.preventDefault();
    // Set the hovered drop zone
 };
 
 const handleDragEnd = () => {
   setDraggedIndex('');
   setHoveredDropZone(null); // Clear hovered drop zone
 };
    


 const fireGetAllChaptersBySectionId=(sectionId)=>{
    setItemArrChapter([]);
   
  
    setItemArrLoadingChapter([{},{},{},{},{}])
  // Popup When Course is not selected
    
  setLoader({status:true});
      // console.log({
      //     token:AppToken,courseId:postIdCourse ,postParent:justSectionSend?.ID,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
      //     appToken:AppToken,visibility:visibility,orderBy:orderBy
      //     });
        const apiData = dispatch(addEntityToAnyEntity({
                       courseId:postIdCourse ,parentEntityType:"section",parentEntityId:sectionId,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
                        appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,visibility:visibility,orderBy:orderBy,
                        editType:"getAllContents",
                        }));
        /* get response as Promise   */
        apiData.then(response => {
          // console.log(response)
  
          if(response){
           
            if(response){
          setResponseMessage(response?.message);
          setSnackbarColor("rgba(144, 202, 249,1)");
        
          if(response?.contents)  {setItemArrChapter(response?.contents); 
            
          
        
          //  console.log(reorderArray)
         
          }else{setItemArrChapter([]);};
          setItemArrLoadingChapter([]);
      setLoader({status:false});
      
      // setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
      },1000)
         }else{
      //     setResponseMessage("Something Went Wrong...");
            
      //     setSnackbarColor("#958FDA");
      //   //  selectCoursePopUp(true);
          
           
      // setLoader({status:false});
      // setItemArrLoading([{},{},{},{},{}]);
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)
         }
            
          // dispatch({
          //   type: "UPDATE_APP_TOKEN",
            
          //   payload:response?.course?.AppToken
          // });  
        //  console.log(response?.course);
       
         // 
         if(response?.logout){
          // pop up response?.logoutInfo
          //console.log(response?.logoutInfo)
      
          setResponseMessage("You are Logged Out!!!");
            
          setSnackbarColor("#958FDA");
         selectCoursePopUp(true);
          
           
      setLoader({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)
          setTimeout(()=>{
            dispatch({type:"LOGOUT"});
      
          },3000)
          
        }
      /* resetting Login input Fields */
      
          }else{
            setResponseMessage("Something Went Wrong...");
            
            setSnackbarColor("#958FDA");
           selectCoursePopUp(true);
           setItemArrLoadingChapter([{},{},{},{},{}]);
             
        setLoader({status:false});
        
        setSnackbarVisible(true);
        setTimeout(()=>{
          
          setSnackbarVisible(false);
         
           
        },3000)    }
      
        }).catch(error => {
       
          //popup of error Info
          setResponseMessage("Something Went Wrong...");
            
          setSnackbarColor("#958FDA");
         selectCoursePopUp(true);
          
           
      setLoader({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)
          console.error(error);
        });
   }

         const handleDeleteChapter=(val,chapterIDK)=>{
           let editType=val;
             
           setLoader({status:true});
         
                 const apiData = dispatch( createNewChapter({
                               token:token,courseId:postIdCourse ,postParent:sectionItem?.ID ,userEmail:user_email?user_email:null,
                               currentToken:currentToken?currentToken:null,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,
                               editType:editType,postId:chapterIDK,menuOrder:1}));
              
             /* get response as Promise   */
             apiData.then(response => {
               if(response){
         
                //  console.log(response)
                 if(response?.chapter){
               setResponseMessage(response?.message);
               setSnackbarColor("rgba(144, 202, 249,1)");
             
                
           setLoader({status:false});
           
           setSnackbarVisible(true);
           setTimeout(()=>{
             
             setSnackbarVisible(false);
            
            if(val=="deleteChapter"){
             // setActiveFilterTwo(false);;setActiveFilterThree(true);
             const removedItems = itemArrChapter.filter(item => item?.ID !== response?.chapter?.ID);
           
             
          setArrayItemsChapter(removedItems)
            } 
             
           },1000)
              }else{
               setResponseMessage("Something Went Wrong...");
                 
               setSnackbarColor("#958FDA");
            
                
           setLoader({status:false});
           
           setSnackbarVisible(true);
           setTimeout(()=>{
             
             setSnackbarVisible(false);
            
              
           },3000)
              }
                 
              
              if(response?.logout){
              
               setResponseMessage("You are Logged Out!!!");
                 
               setSnackbarColor("#958FDA");
            
                
           setLoader({status:false});
           
           setSnackbarVisible(true);
           setTimeout(()=>{
             
             setSnackbarVisible(false);
            
              
           },3000)
               setTimeout(()=>{
                 dispatch({type:"LOGOUT"});
           
               },3000)
               
             }
           /* resetting Login input Fields */
           
               }else{
                 setResponseMessage("Something Went Wrong...");
                 
                 setSnackbarColor("#958FDA");
              
                  
             setLoader({status:false});
             
             setSnackbarVisible(true);
             setTimeout(()=>{
               
               setSnackbarVisible(false);
              
                
             },3000)    }
           
             }).catch(error => {
            
               //popup of error Info
               setResponseMessage("Something Went Wrong...");
                 
               setSnackbarColor("#958FDA");
            
                
           setLoader({status:false});
           
           setSnackbarVisible(true);
           setTimeout(()=>{
             
             setSnackbarVisible(false);
            
              
           },3000)
               console.error(error);
             });
            
             }


             
   const flattenedDataChapter = itemArrChapter!=[]?Object.values(itemArrChapter):'';

   const flattenedDataLoadingChapter = itemArrLoadingChapter!=[]?Object.values(itemArrLoadingChapter):'';

   const flattenedDataChapterInn = itemArrChapterInn!=[]?Object.values(itemArrChapterInn):'';
    return (<>
        {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}
        <div  align="left" className=""  >


        <div  align="left" className=" " style={{margin:"5px",marginTop:"10px",position:"relative",background:"#f1f1f1",padding:"5px",borderRadius:"10px"}}> 
            <div className="gridForWhatsNextAfterYT5">
            <div  align="left" className=" " style={{margin:"5px",position:"relative"}}> 
            <h2 className="ellipsisTitleSubCourse" style={{color:"#222",left:"40px"}}>MileStone {mileStoneSectionSend?.menuOrder}  For Sub-Course {SubCourseData?.menuOrder} - " {SubCourseData?.Name} " </h2>
            <h5  className="ellipsisSubTitleSubCourse"style={{color:"#222"}}>{mileStoneSectionSend?.Description}</h5>
            <div className="" style={{padding:"5px",display:"flex",justifyContent:"flex-start",position:"relative",height:"30px"}}> 
          <div className="" style={{padding:"5px",display:"flex",justifyContent:"flex-start"}}> 
              <BellElectric strokeWidth={1}  size={20}    color="#222"/>  <div style={{padding:"5px",fontSize:"12px",color:"#222"}}> 5  Sections</div>
                </div><div className="" style={{padding:"5px",display:"flex",justifyContent:"flex-start"}}> 
              <ImagePlay strokeWidth={1}  size={20}    color="#222"/>  <div style={{padding:"5px",fontSize:"12px",color:"#222"}}> 5  Chapters</div>
                </div>
                <div className="" style={{padding:"5px",display:"flex",justifyContent:"flex-start"}}> 
              <FolderHeart strokeWidth={1}  size={20}    color="#222"/>  <div style={{padding:"5px",fontSize:"12px",color:"#222"}}> 
                5  Folders</div>
                </div>
        </div></div>
            <div className="gridForFolderFilter">
          
           <FolderFilterCardTwo   activeCard={activeFilterTwo}  icon={6} title ="Show All" onClickPopup={()=>{setVisibility('public');
             setActiveFilterTwo(true);;setActiveFilterThree(false);setActiveFilterFour(false); 
           } }  />
           <FolderFilterCardTwo   activeCard={activeFilterThree}  icon={6} title ="Show Deleted" onClickPopup={()=>{setVisibility('trash');
              setActiveFilterTwo(false);;setActiveFilterThree(true);setActiveFilterFour(false); 
           } }  />
           <FolderFilterCardThree   activeCard={activeFilterASC}  icon={6} title ="ASC" onClickPopup={()=>{
             setActiveFilterASC(true);setActiveFilterDESC(false); setOrderBy("ASC");
              
           } }  /> 
           <FolderFilterCardThree   activeCard={activeFilterDESC}  icon={6} title ="DESC" onClickPopup={()=>{ 
              setActiveFilterASC(false);setActiveFilterDESC(true);setOrderBy("DESC")
               
           } }  /> 
           {/* <FolderFilterCardTwo   activeCard={activeFilterFour}  icon={6} title ="Import" onClickPopup={()=>{} }  />  */}
           
            
           </div>
            </div>
          
            </div>
            <h3  align="left">{flattenedData?.length?"Showing "  +(flattenedData?.length):flattenedDataLoading?"Searching ":"No"} {flattenedDataLoading.length?" Sections ":activeFilterTwo?flattenedData?.length>1?" Sections":" Section":activeFilterThree?" Deleted Sections":""}  for MileStone {mileStoneSectionSend?.menuOrder} 
  {flattenedData?.length?activeFilterTwo&&activeFilterASC?" In Ascending Order  ":activeFilterTwo||activeFilterThree?" In Descending Order  ":"":""} </h3>

            <div className="gridForWhatsNextAfterSections"   >
            <div   style={{}}>
            
            {flattenedDataLoading?.length==0?flattenedData?.length?flattenedData?.map((item, index) => 
        (<div  index={index} key={item?.ID}    >
            

{item?.postType=="chapter"||item?.postType=="folder"?
<div  index={index} key={item?.ID} style={{margin:"0px",marginTop:"10px",padding:"0px",paddingLeft:"0px",background:"#ffffff"}}   >
<div  className="courseContentItemOuterHeadActiveSettings" style={{margin:"10px",marginTop:"0px",padding:"10px",paddingLeft:"10px",background:"#ffffff"}} >
<div className="courseContentItemJustifyContentIcons">{ item?.postType=="folder"?<img     src={contentfolder} 
        alt="selected Img"
   style={{cursor:"pointer",width:"25px",height:"25px"
    
   }}/>:visibility=="public"?
   item?.postType=="chapter"?<Film  onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
   color="rgba(144, 202, 249,1)" style={{padding:"5px",background:"rgba(144, 202, 249,0.1)",borderRadius:"5px",cursor:"pointer",cursor: 'move',}}/> :<div></div>:<div></div>}
   
 </div><div className="courseContentItemJustifyContent"> <div className="themeNone "
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
  {item?.menuOrder}:  {item?.postType=="folder"?"Folder":item?.postType=="chapter"?"Chapter":""} -  {item?.Name}
 
      </div></div><div  className="courseContentItemOuterHeadActiveSettingsInnTwo"
         style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
            {visibility=="public"&&item?.postType=="chapter"?<div align="center" onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} onClick={()=>{setOpenContentInFolder(true);setCurrentChapterId((prev)=>item?.contentID);setNewFolderInChapterPopUp(true);}} strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="rgba(144, 202, 249,1)" style={{padding:"4px",paddingTop:"5px",background:"rgba(144, 202, 249,0.1)",height:"18px",
    fontSize:"13px",borderRadius:"5px",color:"#222"
 ,marginRight:"10px",cursor:"pointer"}}>Add 
 <span className="hidexs"> Folder</span> </div> :<div></div>} 
{visibility=="public"&&item?.postType=="chapter"?<Pencil onClick={()=>{ setChapterItem(item);;setNewChapterPopUp(true);}} 
   onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
   color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",
    fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/>:<div  onClick={()=>{setCurrentFolder(item);setOpenFolderContentPopUp(true)}}>
      <Pencil 
   onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
   color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",
    fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/>
    </div> }
    
          {visibility=="public"?<Trash2  onClick={()=>{setDeleteItemChapterPopUp('deleteChapter')  ;setItemChapterId(item?.ID) ;setSectionID(item?.ID);setCurrentEntityId(item?.ID);}}  onMouseEnter={handleMouseEnter}
                   onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
         color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",
            fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/> :
         <Recycle onClick={()=>{setDeleteItemChapterPopUp('restoreChapter') ;setItemChapterId(item?.ID);setCurrentEntityId(item?.ID);  }}  onMouseEnter={handleMouseEnter}
                   onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
         color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",
            fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/>}
         </div>
         {visibility=="public"?currentChapterID==item?.contentID?<ChevronUp onClick={()=>{ fireGetAllContentssByChapterId(itemArr?.contentID);setCurrentChapterId("");;setOpenContentInFolder(false)}}  onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18}  color="rgba(255,114,94,0.7)" style={{padding:"2px",cursor:"pointer"}}/> 
           :<ChevronDown onClick={()=>{
               fireGetAllContentssByChapterId(item?.contentID);setCurrentChapterId(item?.contentID);setOpenContentInFolder(true)
             }}  onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18}  color="rgba(255,114,94,0.7)" style={{padding:"2px",cursor:"pointer"}}/> 
           :""} 
             {deleteItemChapterPopUp=='deleteChapter'&&currentEntityID==item?.ID?<AreYouSurePopUp loadingText="Deleting..."  title="Delete This Chapter" type="deleteChapter"
 closePopUp={()=>{setDeleteItemChapterPopUp(false)}}
 onClickPopup={(type)=>{handleDeleteChapter(type,item?.ID);;setCurrentEntityId("");setTimeout(()=>{setDeleteItemChapterPopUp(false)},1000)
  }}/>:deleteItemChapterPopUp=='restoreChapter'&&currentEntityID==item?.ID?<AreYouSurePopUp loadingText="Restoring..." title="Restore This Chapter" type="restoreChapter" closePopUp={()=>{setDeleteItemPopUp(false)}} 
  onClickPopup={(type)=>{handleDeleteChapter(type,item?.ID);;setCurrentEntityId("");setTimeout(()=>{setDeleteItemChapterPopUp(false)},1000)
  }}/>:""}
      
 </div>
 
 <div  className="chapterContentFolderItemGridOuter">
  {openContentInFolder&&currentChapterID==item?.contentID?flattenedDataChapterInn?.length?flattenedDataChapterInn?.map((itemFF, indexFF) => 
        (<div  index={indexFF} key={itemFF?.ID}    >
 <div  className="chapterContentItemGridOuter" style={{margin:"10px",marginTop:"0px",padding:"10px",background:" rgba(144, 202, 249,0.2)"}}>
  <div className="courseContentItemJustifyContentIcons"><img     src={contentfolder} 
        alt="selected Img"
   style={{cursor:"pointer",width:"40px",height:"40px"
    
   }}/>
   </div> <div className="courseContentItemJustifyContentIcons">
   </div><div className="courseContentItemJustifyContent"> <div className="themeNone "
   style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
    {indexFF+1}: {itemFF?.postType=="folder"?"Folder":itemFF?.postType=="chapter"?"Chapter":""}  - {itemFF?.Name}
   
        </div></div>
        
        
        <div  className="courseContentItemOuterHeadActiveSettingsInnTwo"
   style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
   <div  onClick={()=>{setCurrentFolder(itemFF);setOpenFolderContentPopUp(true)}}>
      <Pencil 
   onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
   color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",
    fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/>
    </div>
  <div></div> 
  
   {visibility=="public"?<Trash2  onClick={()=>{handleDeleteFolderInChapter("deleteChapter",itemFF?.ID);}}  onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
   color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",
    fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/> :
   <Recycle onClick={()=>{  }}  onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
   color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",
    fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/>}
      </div>
     </div> </div>)):"":""} </div>  </div>



:item?.postType=="section"?<>
{selectedItemIndex!==index?
<div
            className="drop-zone"
            onDragOver={(e) => {setHoveredDropZone(index);
              handleDragOver(e, index)
            }}
            onDrop={(e) => {handleDrop(e, index);setSelectedItemIndex(null);}}
          
            style={{
              height: hoveredDropZone === index ?'95px':"0px",position:hoveredDropZone === index ?'relative':"",left:"0px",right:"0px",
              backgroundColor: hoveredDropZone === index ? 'rgba(149, 143, 218,0.2) ' : 'transparent', // Change color on hover
              border: hoveredDropZone === index ? '2px dashed rgba(149, 143, 218,1) ' : 'transparent', // Change color on hover
              transition: 'background-color  0.3s ease',width:"95%",
              borderRadius: '10px',marginBottom:hoveredDropZone === index ?"10px":"0px"
             
            }}
          ></div>:""}
            <div

onDragOver={(e) => { if(selectedItemIndex!==index){setHoveredDropZone(index);
    handleDragOver(e, index)}
  }}
  onDrop={(e) => {if(selectedItemIndex!==index){handleDrop(e, index);setSelectedItemIndex(null);}}}

             draggable 
             onDragStart={(e) =>{ handleDragStart(e, index);
              setDraggedIndex(item.ID); setSelectedItemIndex(index);
             }}className={draggedIndex == item.ID?"posFixed":"posRelative"  }
             style={{background:"rgba(144, 202, 249,0.1)",borderBottom:"3px solid #fff", margin:"0px",marginBottom:"10px",padding:"0px",
                marginRight:"15px",position:"relative",borderRadius:"10px",overflow:"hidden",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.021)"}} 
          
              onDragEnd={handleDragEnd}
            >
          {<div  style={{height:"19px",
            zIndex:"9999", top:"0px",}} 
          className="product-tag-theme1">  <div  
          color="#666666" align="center" style={{padding:"4px",float:"left",width:"10px",height:"10px",
          background:"#ffffff",color:"#222",borderRadius:"15px",cursor:"pointer",cursor: 'move',marginRight:"10px"}}>{item?.menuOrder}</div>{item?.postType=="section"? "Section":item?.postType=="folder"?"Folder":""}  </div>}
            <div  className="courseContentItemOuterHeadActiveSettings" style={{margin:"10px",marginTop:"0px",padding:"10px",paddingLeft:"10px",background:"transparent"}}>
<div className="courseContentItemJustifyContentIcons">{visibility=="public"?<GripHorizontal  onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="rgba(144, 202, 249,1)" style={{padding:"4px",background:"#ffffff",border:"2px solid rgba(144, 202, 249,1)",borderRadius:"5px",cursor:"pointer",cursor: 'move',}}/> :<div></div>}
 </div><div className="courseContentItemJustifyContent" style={{display:"flex",justifyContent:"left"}}> { item?.postType=="folder"?<img     src={contentfolder} 
        alt="selected Img"
   style={{cursor:"pointer",width:"35px",height:"35px",marginLeft:"10px"
    
   }}/>:""}<div className="themeNone "
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
 
   
  
   {item?.Name}
 
      </div></div><div  className="courseContentItemOuterHeadActiveSettingsInnTwo"
 style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
  {visibility=="public"?item?.postType=="section"? <div align="center" onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} onClick={()=>{setSectionItem(item);setCreateNewChapterPopUp(true)}} strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="rgba(144, 202, 249,1)" style={{padding:"4px",paddingTop:"5px",background:"#fff"
    ,border:"2px solid rgba(144, 202, 249,1)",height:"18px",width:"70px",
    fontSize:"13px",borderRadius:"5px",color:"rgba(144, 202, 249,1)"
 ,marginRight:"10px",cursor:"pointer"}}>Add 
 <span className="hidexs"> Contents</span> </div> :item?.postType=="folder"?
 <div> </div>:"":<div></div>}
{visibility=="public"&&item?.postType=="section"?<Pencil onClick={()=>{ setSectionItem(item);setNewSectionPopUp(true);}} 
 onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="rgba(144, 202, 249,1)" style={{padding:"4px",background:"#ffffff",border:"2px solid rgba(144, 202, 249,1)",borderRadius:"5px",cursor:"pointer"}}/>:<div  onClick={()=>{setCurrentFolder(item);setOpenFolderContentPopUp(true)}}>
      <Pencil 
   onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
   color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",
    fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/>
    </div> }
          
{visibility=="public"?<Trash2  onClick={()=>{setItemId(item?.contentID);setDeleteItemPopUp('deleteSection') ;}}  onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="rgba(144, 202, 249,1)" style={{padding:"4px",background:"#ffffff",border:"2px solid rgba(144, 202, 249,1)",borderRadius:"5px",cursor:"pointer"}}/> :
 <Recycle onClick={()=>{setItemId(item?.contentID);setDeleteItemPopUp('restoreSection') ;  }}  onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="rgba(144, 202, 249,1)" style={{padding:"4px",background:"#ffffff",border:"2px solid rgba(144, 202, 249,1)",borderRadius:"5px",cursor:"pointer"}}/>}
 </div>
  {visibility=="public"&&item?.postType=="section"?itemId==item?.contentID&&flattenedDataChapter?.length?
  <ChevronUp onClick={()=>{ setItemId("");}}  onMouseEnter={handleMouseEnter}
onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18}  color="rgba(255,114,94,0.7)" style={{padding:"2px",cursor:"pointer"}}/> 
:<ChevronDown onClick={()=>{setItemId(item?.contentID);fireGetAllChaptersBySectionId(item?.contentID);
   
  }}  onMouseEnter={handleMouseEnter}
 onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18}  color="rgba(255,114,94,0.7)" style={{padding:"2px",cursor:"pointer"}}/> 
:""}</div>
  {deleteItemPopUp=='deleteSection'&&itemId==item?.contentID?<AreYouSurePopUp loadingText="Deleting..."  title="Delete This Section" type="deleteSection"
 closePopUp={()=>{setDeleteItemPopUp(false)}}
 onClickPopup={(type)=>{handleDeleteSection(type,item?.ID);setTimeout(()=>{setDeleteItemPopUp(false)},1000)
  }}/>:deleteItemPopUp=='restoreSection'&&itemId==item?.contentID?<AreYouSurePopUp loadingText="Restoring..." title="Restore This Section" type="restoreSection" closePopUp={()=>{setDeleteItemPopUp(false)}} 
  onClickPopup={(type)=>{handleDeleteSection(type,item?.ID);setTimeout(()=>{setDeleteItemPopUp(false)},1000)
  }}/>:""}
{itemId==item?.contentID?flattenedDataChapter?.length?flattenedDataChapter?.map((itemChapter, indexChapter) => 
        (<div  index={indexChapter} key={itemChapter?.ID} style={{margin:"0px",marginTop:"10px",padding:"0px",paddingLeft:"0px",background:"#ffffff"}}   >
<div  className="courseContentItemOuterHeadActiveSettings" style={{margin:"10px",marginTop:"0px",padding:"10px",paddingLeft:"10px",background:"#ffffff"}} >
<div className="courseContentItemJustifyContentIcons">{ itemChapter?.postType=="folder"?<img     src={contentfolder} 
        alt="selected Img"
   style={{cursor:"pointer",width:"25px",height:"25px"
    
   }}/>:visibility=="public"?
   itemChapter?.postType=="chapter"?<Film  onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
   color="rgba(144, 202, 249,1)" style={{padding:"5px",background:"rgba(144, 202, 249,0.1)",borderRadius:"5px",cursor:"pointer",cursor: 'move',}}/> :<div></div>:<div></div>}
   
 </div><div className="courseContentItemJustifyContent"> <div className="themeNone "
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
  {itemChapter?.menuOrder}:  {itemChapter?.postType=="folder"?"Folder":itemChapter?.postType=="chapter"?"Chapter":""} -  {itemChapter?.Name}
 
      </div></div><div  className="courseContentItemOuterHeadActiveSettingsInnTwo"
         style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
            {visibility=="public"&&itemChapter?.postType=="chapter"?<div align="center" onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} onClick={()=>{setOpenContentInFolder(true);setCurrentChapterId((prev)=>itemChapter?.contentID);setNewFolderInChapterPopUp(true);}} strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="rgba(144, 202, 249,1)" style={{padding:"4px",paddingTop:"5px",background:"rgba(144, 202, 249,0.1)",height:"18px",
    fontSize:"13px",borderRadius:"5px",color:"#222"
 ,marginRight:"10px",cursor:"pointer"}}>Add 
 <span className="hidexs"> Folder</span> </div> :<div></div>} 
{visibility=="public"&&itemChapter?.postType=="chapter"?<Pencil onClick={()=>{ setChapterItem(itemChapter);;setNewChapterPopUp(true);}} 
   onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
   color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",
    fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/>:<div  onClick={()=>{setCurrentFolder(itemChapter);setOpenFolderContentPopUp(true)}}>
      <Pencil 
   onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
   color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",
    fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/>
    </div> }
    
          {visibility=="public"?<Trash2  onClick={()=>{setDeleteItemChapterPopUp('deleteChapter')  ;setItemChapterId(itemChapter?.ID) ;setSectionID(item?.ID);setCurrentEntityId(itemChapter?.ID);}}  onMouseEnter={handleMouseEnter}
                   onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
         color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",
            fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/> :
         <Recycle onClick={()=>{setDeleteItemChapterPopUp('restoreChapter') ;setItemChapterId(itemChapter?.ID);setCurrentEntityId(itemChapter?.ID);  }}  onMouseEnter={handleMouseEnter}
                   onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
         color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",
            fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/>}
         </div>
         {visibility=="public"?currentChapterID==itemChapter?.contentID?<ChevronUp onClick={()=>{ fireGetAllContentssByChapterId(itemChapter?.contentID);setCurrentChapterId("");;setOpenContentInFolder(false)}}  onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18}  color="rgba(255,114,94,0.7)" style={{padding:"2px",cursor:"pointer"}}/> 
           :<ChevronDown onClick={()=>{
               fireGetAllContentssByChapterId(itemChapter?.contentID);setCurrentChapterId(itemChapter?.contentID);setOpenContentInFolder(true)
             }}  onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18}  color="rgba(255,114,94,0.7)" style={{padding:"2px",cursor:"pointer"}}/> 
           :""} 
             {deleteItemChapterPopUp=='deleteChapter'&&currentEntityID==itemChapter?.ID?<AreYouSurePopUp loadingText="Deleting..."  title="Delete This Chapter" type="deleteChapter"
 closePopUp={()=>{setDeleteItemChapterPopUp(false)}}
 onClickPopup={(type)=>{handleDeleteChapter(type,itemChapter?.ID);;setCurrentEntityId("");setTimeout(()=>{setDeleteItemChapterPopUp(false)},1000)
  }}/>:deleteItemChapterPopUp=='restoreChapter'&&currentEntityID==itemChapter?.ID?<AreYouSurePopUp loadingText="Restoring..." title="Restore This Chapter" type="restoreChapter" closePopUp={()=>{setDeleteItemPopUp(false)}} 
  onClickPopup={(type)=>{handleDeleteChapter(type,itemChapter?.ID);;setCurrentEntityId("");setTimeout(()=>{setDeleteItemChapterPopUp(false)},1000)
  }}/>:""}
        {/* {deleteItemChapterPopUp=='deleteChapter'&&currentEntityID==itemChapter?.ID?<AreYouSurePopUp loadingText="Deleting..."  title={"Delete This Item"} type="deleteChapter"
 closePopUp={()=>{setDeleteItemPopUp(false)}}
 onClickPopup={(type)=>{handleDeleteChapter(type,itemChapter?.ID);setCurrentEntityId("");setTimeout(()=>{setDeleteItemChapterPopUp(false);},1000)
  }}/>:deleteItemPopUp=='restoreChapter'&&currentEntityID==itemChapter?.ID?<AreYouSurePopUp loadingText="Restoring..." title={"Restore This Item"} type="restoreChapter" closePopUp={()=>{setDeleteItemPopUp(false)}} 
  onClickPopup={(type)=>{handleDeleteChapter(type,itemChapter?.ID);setTimeout(()=>{setDeleteItemChapterPopUp(false);},1000)
  }}/>:""} */}
 </div>
 
 <div  className="chapterContentFolderItemGridOuter">
  {openContentInFolder&&currentChapterID==itemChapter?.contentID?flattenedDataChapterInn?.length?flattenedDataChapterInn?.map((itemFF, indexFF) => 
        (<div  index={indexFF} key={itemFF?.ID}    >
 <div  className="chapterContentItemGridOuter" style={{margin:"10px",marginTop:"0px",padding:"10px",background:" rgba(144, 202, 249,0.2)"}}>
  <div className="courseContentItemJustifyContentIcons"><img     src={contentfolder} 
        alt="selected Img"
   style={{cursor:"pointer",width:"40px",height:"40px"
    
   }}/>
   </div> <div className="courseContentItemJustifyContentIcons">
   </div><div className="courseContentItemJustifyContent"> <div className="themeNone "
   style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
    {indexFF+1}: {itemFF?.postType=="folder"?"Folder":itemFF?.postType=="chapter"?"Chapter":""}  - {itemFF?.Name}
   
        </div></div>
        
        
        <div  className="courseContentItemOuterHeadActiveSettingsInnTwo"
   style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
   <div  onClick={()=>{setCurrentFolder(itemFF);setOpenFolderContentPopUp(true)}}>
      <Pencil 
   onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
   color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",
    fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/>
    </div>
  <div></div> 
  
   {visibility=="public"?<Trash2  onClick={()=>{handleDeleteFolderInChapter("deleteChapter",itemFF?.ID);}}  onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
   color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",
    fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/> :
   <Recycle onClick={()=>{  }}  onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
   color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",
    fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/>}
      </div>
     </div> </div>)):"":""} </div>  </div> )):flattenedDataLoadingChapter?.length==0?flattenedDataChapter?.length?"":<div align="center"style={{margin:"15px",padding:"10px",borderRadius:"15px",background:"rgba(255,114,94,0.1)"}}><h3 style={{"textAlign":"center",
       
}}> Opps... <span className="coloredTextV1">No Chapter Found !!!</span> Create Your First Chapter In This Section  And  Add Folders.     </h3>
<div align="center" onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} onClick={()=>{setSectionItem(item);setCreateNewChapterPopUp(true)}} strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="#222" style={{padding:"4px",paddingTop:"5px",background:"#fff"
    ,border:"2px solid #222",height:"25px",width:"100px",fontWeight:"999",
    fontSize:"17px",borderRadius:"5px",color:"#222"
 ,marginRight:"10px",cursor:"pointer"}}>Add 
 <span className="hidexs"> Chapters</span> </div>
</div>: <div>
         
         <div  className="chapterContentItemGridOuter" style={{margin:"10px",minHeight:"40px",marginTop:"10px",paddingLeft:"10px",background:"#ffffff"}}>
         <div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div> <div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
   </div><div  className="text-linetw" style={{marginTop:"0px",height:"25px",width:"94%",paddingLeft:"10px",padding:"5px"}}>
</div><div  className="courseContentItemOuterHeadActiveSettingsInnTwo"
   style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
     <div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"74%",paddingLeft:"10px",padding:"5px"}}>
    
    </div>  <div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div><div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div></div>
     </div><div  className="chapterContentItemGridOuter" style={{margin:"10px",minHeight:"40px",marginTop:"10px",paddingLeft:"10px",background:"#ffffff"}}>
         <div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div> <div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
   </div><div  className="text-linetw" style={{marginTop:"0px",height:"25px",width:"94%",paddingLeft:"10px",padding:"5px"}}>
</div><div  className="courseContentItemOuterHeadActiveSettingsInnTwo"
   style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
     <div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"74%",paddingLeft:"10px",padding:"5px"}}>
    
    </div>  <div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div><div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div></div>
     </div>
</div>:""}
 </div></>:""}</div>)):"":""}












{flattenedDataLoading?flattenedDataLoading?.map((item, index) => 
        (<div  index={index} key={item?.ID}    >

            <div
className={"posRelative"  }
             style={{ margin:"10px",background:"rgba(144, 202, 249,0.1)",marginTop:"15px",padding:"10px",
                marginRight:"15px",position:"relative",borderRadius:"10px",overflow:"hidden",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.021)"}} 
          
             
            >
         
         <div  className="chapterContentItemGridOuter" style={{margin:"0px",marginTop:"-20px",paddingLeft:"10px",background:"transparent"}}>
         <div className="text-linetw "  style={{marginTop:"10px",marginRight:"10px",height:"35px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div> <div className="text-linetw "  style={{marginTop:"10px",marginRight:"10px",height:"35px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
   </div><div  className="text-linetw" style={{marginTop:"10px",height:"35px",width:"94%",paddingLeft:"10px",padding:"5px"}}>
</div><div  className="courseContentItemOuterHeadActiveSettingsInnTwo"
   style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
     <div className="text-linetw "  style={{marginTop:"10px",marginRight:"10px",height:"35px",width:"74%",paddingLeft:"10px",padding:"5px"}}>
    
    </div>  <div className="text-linetw "  style={{marginTop:"10px",marginRight:"10px",height:"35px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div><div className="text-linetw "  style={{marginTop:"10px",marginRight:"10px",height:"35px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div></div>
    </div>
    <div  className="chapterContentItemGridOuter" style={{margin:"0px",minHeight:"40px",marginTop:"10px",paddingLeft:"10px",background:"#ffffff"}}>
         <div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div> <div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
   </div><div  className="text-linetw" style={{marginTop:"0px",height:"25px",width:"94%",paddingLeft:"10px",padding:"5px"}}>
</div><div  className="courseContentItemOuterHeadActiveSettingsInnTwo"
   style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
     <div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"74%",paddingLeft:"10px",padding:"5px"}}>
    
    </div>  <div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div><div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div></div>
     </div></div></div>)):""}

      {flattenedDataLoading?.length==0?flattenedData?.length?"": <div align="center"style={{margin:"15px",padding:"10px",borderRadius:"15px",background:"rgba(255,114,94,0.1)"}}><h3 style={{"textAlign":"center",
       
    }}> Opps... <span className="coloredTextV1">No Section Found !!!</span> {activeFilterThree?" Deleted Sections Will Show Up Here..."
    :"Create Your First Section In Milestone "+mileStoneSectionSend?.menuOrder+ " And  Add Chapters & Folders."}     </h3>
    <h5>
       </h5>
    </div>:""}
</div>



<div className="hideXsForApp">
    
<AddToFolderButton title ="Add Section" onClickPopup={()=>{ setSectionItem({});setNewSectionPopUp(true);}}  />
        {/* <AddToFolderButton title ="Add Chapter" onClickPopup={()=>{}} /> */}
        <AddToFolderButton title ="Add Folder" onClickPopup={()=>{setSectionItem({});setNewFolderInSectionPopUp(true);}}  />
</div>
</div>
  
            <div className="gridForWhatsNextAfterYT5">
            <div  className=""style={{display:"flex",justifyContent:"space-between",
alignContent:"center",textAlign:"center",gap:"0px",margin:"0px",zIndex:"99",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}>
<AddToFolderButton title ="Add Section" onClickPopup={()=>{ setSectionItem({});setNewSectionPopUp(true);}}  />
        {/* <AddToFolderButton title ="Add Chapter" onClickPopup={()=>{}} /> */}
        <AddToFolderButton title ="Add Folder" onClickPopup={()=>{setSectionItem({});setNewFolderInSectionPopUp(true);}}  />
          <div style={{width:"70px"}}></div>
      </div>
            </div>






 {createNewChapterPopUp? <div>    <div  onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}  className="selectThumbImgOuterAll"  onClick={()=>setCreateNewChapterPopUp(false)}  style={{zIndex:99999,cursor:"pointer",}}>
 </div>
  
    <div  className="CreateChaptersPopUpOuter"  style={{zIndex:999999,background:"#ffffff",overflowY:"auto"}}>
    <div onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}  style={{width:"40px",height:"40px",cursor:"pointer",
         borderRadius:"50%",float:"right",margin:"10px",
       background:"#958FDA",zIndex:999999}} onClick={()=>setCreateNewChapterPopUp(false)}   >
         <X  style={{padding:"9px",}} color="#fff" size={22}/></div> 
        
 <div   className="" style={{} }>
              <ChapterFolderPanel setArrayItemsChapter={(data)=>setArrayItemsChapter(data)} sectionItemSend={sectionItem} justSectionSend={sectionItem} setCreateNewChapterPopUp={()=>setCreateNewChapterPopUp(false)} selectCoursePopUp={selectCoursePopUp} SubCourseData={SubCourseData} />
            </div></div></div>:""}




      {newFolderInChapterPopUp? <div><div onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{setNewChapterPopUp(false)}} style={{cursor:"pointer"}}  align="center" className="appDesignPopUpOpacity"> </div>
        <div  align="center" className="createNewSectionPopUp" style={{borderRadius: '5px',background:"#f9f9f9"}}> 
       
<CreateFolderInChapterPopup
 sendBackItem={(item)=>{sendBackItemChapterInn({...item,postType:"folder",menuOrder:itemArr?.length+1})}}
parentEntityType={"chapter"} parentEntityID={currentChapterID} menuOrder={flattenedDataChapter?.length+1}

   setClosePopUp={()=>setNewFolderInChapterPopUp(false)} />

   </div></div>:""} 


              {openAppDesignPopUp?<div className="appDesignPopUp"  style={{zIndex:99999} }>
   <div   onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} style={{cursor:"pointer",}} onClick={()=>{setopenAppDesignPopUp()}} 
            className="appDesignPopUpOpacity"></div>
   <div   className="appDesignPopUpInner " style={{margin:'0px',
    overflowY: "auto",zIndex:9999999,background:"#f9f9f9"}}>
         
        <div className="userInfoLiner" style={{background:"#ffffff"}} >
        <div className="userInfoLinerInn" style={{background:"#ffffff"}}>
        
          <img  className="userInfoLinerPic"src={user?.profile_pic?user?.profile_pic:"https://img.freepik.com/free-vector/illustration-businessman_53876-5856.jpg"} alt={user?.profile_pic} />
           
      </div>  
      </div><div className="userInfoLinerName">
              {openAppDesignPopUpInnerContent=="createMileStone"?
         <CreateMileStonePopup subCourseItem={SubCourseData} menuOrder={flattenedData?.length+1} sendBackItem={(subCourse)=>{sendBackItem(subCourse)}} changeItemData={(id,data)=>{updateItemData(id,data)} }  mileStoneItem={mileStoneItem} setopenAppDesignPopUp={setopenAppDesignPopUp} /> 
      :""}</div>
      </div>
      </div>:""}
      
    
{newFolderInSectionPopUp? <div><div onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{setNewFolderInSectionPopUp(false)}} style={{cursor:"pointer"}}  align="center" className="appDesignPopUpOpacity"> </div>
        <div  align="center" className="createNewSectionPopUp" style={{borderRadius: '5px',background:"#f9f9f9"}}> 
       
<CreateFolderInChapterPopup
 sendBackItem={(item)=>{sendBackItem({...item,postType:"folder",menuOrder:itemArr?.length+1})}}
parentEntityType={"Milestone"} parentEntityID={mileStoneSectionSend?.ID} menuOrder={flattenedData?.length+1}

   setClosePopUp={()=>setNewFolderInSectionPopUp(false)} />

   </div></div>:""}
    

      {newSectionPopUp? <div><div onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{setNewSectionPopUp(false)}} style={{cursor:"pointer"}}  align="center" className="appDesignPopUpOpacity"> </div>
        <div  align="center" className="createNewSectionPopUp" style={{borderRadius: '5px',background:"#f9f9f9"}}> 
        <div >
        <div align="center">
       
<CreateSectionPopup  sectionItem={sectionItem} menuOrder={flattenedData?.length+1} sendBackItem={(subCourse)=>{sendBackItem(subCourse)}} changeItemData={(id,data)=>{updateItemData(id,data)} }  mileStoneItem={mileStoneSectionSend} setNewSectionPopUp={()=>setNewSectionPopUp(false)} />

   </div></div></div></div>:""}


   {newChapterPopUp? <div><div onMouseEnter={handleMouseEnter}
       onMouseLeave={handleMouseLeave} onClick={()=>{setNewChapterPopUp(false)}} style={{cursor:"pointer"}}  align="center" className="appDesignPopUpOpacity"> </div>
           <div  align="center" className="createNewSectionPopUp" style={{borderRadius: '5px',background:"#f9f9f9"}}> 
          
   <CreateChapterPopup chapterItem={chapterItem} menuOrder={flattenedDataChapter?.length+1}
    sendBackItem={(chapter)=>{sendBackItemChapter(chapter)}} changeItemData={(id,data)=>{updateItemChapterData(id,data)} }
      sectionItem={sectionItem} setNewChapterPopUp={()=>setNewChapterPopUp(false)} />
   
      </div></div>:""}


      {openFolderContentPopUp?<FolderContentPopUp item={currentFolder} closePopUp={()=>{ setOpenFolderContentPopUp(false)}} />:""}
        
        </div></>)
}
export default SectionFolderPanel;

